import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { readCookieConsent } from '../lib/cookieConsent';
import { trackPageView } from '../utils/analytics';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Scroll to top on route change
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });

    // GA4 page_view only after analytics consent (see CookieConsent banner)
    if (readCookieConsent()?.analytics) {
      trackPageView(pathname);
    }
  }, [pathname]);

  return null;
};

export default ScrollToTop;
